import React from 'react';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import { Box, Link, Stack, Typography } from '@mui/material';
import { Image } from 'mui-image';
import ELF_Icon from '../assets/ELF_Icon+Type_CMYK.png';
import { ELF_TEAL } from '../Pages/Portal/elfTheme';

const LOAN_SUBNAV = [
  { path: '/portal/loans', label: 'Home', end: true },
  { path: '/portal/loans/pay', label: 'Pay' },
  { path: '/portal/loans/documents', label: 'Documents' },
  { path: '/portal/loans/history', label: 'History' },
];

function isActive(pathname: string, path: string, end?: boolean): boolean {
  if (end) return pathname === path;
  return pathname === path || pathname.startsWith(`${path}/`);
}

/** Loan section chrome with ELF branding and subnav. */
const LoansLayout: React.FC = () => {
  const location = useLocation();

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
          mb: 2,
          pb: 2,
          borderBottom: `3px solid ${ELF_TEAL}`,
        }}
      >
        <Image
          src={ELF_Icon}
          alt="Educational Loan Fund"
          width={120}
          style={{ objectFit: 'contain' }}
        />
        <Box>
          <Typography
            variant="overline"
            sx={{ color: ELF_TEAL, letterSpacing: 1 }}
          >
            Educational Loan Fund
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Borrower portal
          </Typography>
        </Box>
      </Box>

      <Stack
        direction="row"
        spacing={2}
        sx={{ mb: 3, flexWrap: 'wrap', gap: 1 }}
      >
        {LOAN_SUBNAV.map((item) => {
          const active = isActive(location.pathname, item.path, item.end);
          return (
            <Link
              key={item.path}
              component={RouterLink}
              to={item.path}
              underline="none"
              sx={{
                fontWeight: active ? 700 : 500,
                color: active ? ELF_TEAL : 'text.secondary',
                borderBottom: active
                  ? `2px solid ${ELF_TEAL}`
                  : '2px solid transparent',
                pb: 0.5,
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </Stack>
      <Outlet />
    </Box>
  );
};

export default LoansLayout;
